// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35_NZ","delete":"styles_delete__2PCJ6","update":"styles_update__2ognB","add":"styles_add__yHC7b"};